import React from 'react';
import Section from '../components/Section';
import TextField from '../components/TextField';

const OUTLET_OPTIONS = ['Velachery', 'T. Nagar', 'Anna Nagar'];

function S0_Identity({ data, onChange, errors, outletLocked }) {
  const today = new Date().toISOString().split('T')[0];

  return (
    <Section title="Who is submitting this report?">
      {/* Report Date */}
      <TextField
        label="Report date"
        type="date"
        value={data.report_date || today}
        onChange={(v) => onChange('report_date', v)}
        required
        hasError={!!errors.report_date}
        errorMsg={errors.report_date}
      />

      {/* Outlet — locked if URL param present */}
      <div className="field-group">
        <label className="field-label">
          Outlet <span className="required-star">*</span>
        </label>
        {outletLocked ? (
          <span className="locked-field">{data.outlet}</span>
        ) : (
          <select
            className={`select-input${errors.outlet ? ' has-error' : ''}`}
            value={data.outlet || ''}
            onChange={(e) => onChange('outlet', e.target.value)}
            aria-required="true"
            aria-invalid={!!errors.outlet}
          >
            <option value="" disabled>
              Select outlet…
            </option>
            {OUTLET_OPTIONS.map((o) => (
              <option key={o} value={o}>
                {o}
              </option>
            ))}
          </select>
        )}
        {errors.outlet && (
          <p className="error-message">{errors.outlet}</p>
        )}
      </div>

      {/* Submitted By */}
      <TextField
        label="Your name"
        value={data.submitted_by || ''}
        onChange={(v) => onChange('submitted_by', v)}
        placeholder="Enter your name"
        required
        hasError={!!errors.submitted_by}
        errorMsg={errors.submitted_by}
      />
    </Section>
  );
}

export default S0_Identity;
